import { render, staticRenderFns } from "./menuButtons.vue?vue&type=template&id=c80a451e"
import script from "./menuButtons.vue?vue&type=script&lang=js"
export * from "./menuButtons.vue?vue&type=script&lang=js"
import style0 from "./menuButtons.vue?vue&type=style&index=0&id=c80a451e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports